import Button, { ButtonProps } from '@components/v2/ui/Button/Button';
import { Divider, Stack } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';

type Action = {
  label: LangEnum;
  onClick: () => void;
  size?: ButtonProps['size'];
};

export interface MultiOptionsSelectorFooterParams {
  actions: Action[];
}

const MultiOptionsSelectorFooter = ({ actions }: MultiOptionsSelectorFooterParams) => {
  const { translate } = useTranslation();

  return (
    <>
      <Divider />
      <Stack
        direction="row"
        sx={{
          gap: 1,
          padding: 1,
          justifyContent: 'flex-end',
        }}
      >
        {actions.map((action) => (
          <Button
            key={action.label}
            color="primary"
            variant="contained"
            size={action.size}
            onClick={action.onClick}
          >
            {translate(action.label)}
          </Button>
        ))}
      </Stack>
    </>
  );
};

export default MultiOptionsSelectorFooter;
